<template>
    <div
        class="estates-list"
        :class="showMap ? 'container-fluid' : 'container no-map'"
    >
        <div class="row-maps">
            <div class="search-top">
                <estates-search-filters
                    v-if="! $root.is_mobile"
                    :config="config"
                    :config_map="config_map"
                    :districts_list="districts_list ? districts_list : districts_list_city"
                    :geo_data="geoData"
                    :section="section"
                    :search-data="filters"
                    :types_list="typesList"
                    :save-search-disable="saveSearchDisable"
                />
            </div>

            <div class="col-lists">
                <div class="result-list">

                    <estates-list-breadcrumb>
                        <template slot="body">
                            <slot name="breadcrumb" />
                        </template>
                    </estates-list-breadcrumb>

                    <estates-list-title>
                        <template slot="body">
                            <slot name="title" />
                        </template>
                    </estates-list-title>

                    <estates-list-cities
                        :cities="search.cities"
                        :cities_list="cities_list ? cities_list : null"
                    >
                        <template slot="body">
                            <slot name="cities-list" />
                        </template>
                    </estates-list-cities>

                    <estates-list-districts
                        :city="filters.city"
                        :districts="search.districts"
                        :districts_list="districts_list ? districts_list : districts_list_city"
                        :quarters="search.quarters"
                    >
                        <template slot="body">
                            <slot name="districts-list" />
                        </template>
                    </estates-list-districts>

                    <estates-list-quarters
                        v-if="search.districts && !search.districts.toString().includes('|')"
                    >
                        <template slot="body">
                            <slot name="quarters-list" />
                        </template>
                    </estates-list-quarters>

                    <estates-list-heading
                        :config="config"
                        :config_map="config_map"
                        :search="filters"
                        :geo_data="geoData"
                        :types_list="typesList"
                        :section="section"
                        :fallback="fallback"
                        :sort_enable="estates ? true : false"
                    >
                        <template slot="estates-count">
                            <slot name="estates-list-heading" />
                        </template>
                    </estates-list-heading>

                    <estates-list
                        :search="filters"
                        :map_center="mapCenter"
                        :pagination="pagination"
                        :section="section"
                        :config="config"
                    >
                        <template slot="estates">
                            <slot name="estate-cards" />
                        </template>

                        <slot name="pagination" />
                    </estates-list>

                    <slot name="seo-links" />
                </div>
            </div>

            <estates-map-list
                v-if="! $root.is_mobile"
                class="col-maps"
                :config_map="config_map"
                :search="filters"
                :section="section"
                :map_center="mapCenter"
                :mapDrawable="config_map.map_drawable && section != 'construction'"
            />
        </div>
    </div>
</template>

<script>
import EstateList from '../../components/estates/List'
import EstateListBreadcrumb from '../../components/estates/ListBreadcrumb'
import EstateListCities from '../../components/estates/ListCities'
import EstateListDistricts from '../../components/estates/ListDistricts'
import EstateListHeading from '../../components/estates/ListHeading'
import EstateListQuarters from '../../components/estates/ListQuarters'
import EstateListTitle from '../../components/estates/ListTitle'
import EstatesMapList from '../../components/estates/MapReworkList'
import EstateSearchFilters from '../../components/estates/SearchFilters'

export default {
    components: {
        'estates-list': EstateList,
        'estates-list-breadcrumb': EstateListBreadcrumb,
        'estates-list-cities': EstateListCities,
        'estates-list-districts': EstateListDistricts,
        'estates-list-heading': EstateListHeading,
        'estates-list-quarters': EstateListQuarters,
        'estates-list-title': EstateListTitle,
        'estates-map-list': EstatesMapList,
        'estates-search-filters': EstateSearchFilters,
    },

    props: {
        config: {
            type: Object,
            required: true,
        },

        config_map: {
            type: Object,
            required: true,
        },

        cities_list: {
            type: Array,
            required: false,
        },

        districts_list: {
            type: Array,
            required: false,
        },

        districts_list_city: {
            type: Array,
            required: false,
        },

        estates: {
            type: Array,
            required: true,
        },

        fallback: {
            type: Object,
            required: false,
        },

        geoData: {
            type: Object,
            required: true,
        },

        mapCenter: {
            type: Array,
            required: true,
        },

        pagination: {
            type: Object,
            required: true,
        },

        saveSearchDisable: {
            type: Boolean,
            default: false,
        },
        
        search: {
            type: Object,
            required: true,
        },

        section: {
            type: String,
            default: 'estate',
        },

        showMap: {
            type: Number,
            default: 1,
        },

        typesList: {
            type: Array,
            required: false,
        },
    },

    data() {
        return {
            filters: this.search,
        }
    },

    // computed: {
    //     lang() {
    //         return this.$root.lang.home
    //     },
    // },

    mounted() {
        window.events.$on('list.update.filters.polygon_id', (event) => {
            this.filters.polygon = event
            this.filters.polygon_id = event
        })

        window.events.$on('list.update.polygon_id', (event) => {
            if (!event) {
                this.filters.polygon = null
                this.filters.polygon_id = null
            }
        })
    }
}
</script>